export default __webpack_public_path__ + "static/media/lalamove_van.46d533ca.png";